import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/** Canjea un enlace de reserva de MCP: un solo uso y vence a los 30 min. */
export const redeemBookingLink = createServerFn({ method: "POST" })
  .inputValidator(z.object({ token: z.string().regex(/^[A-Za-z0-9_-]{20,64}$/) }))
  .handler(async ({ data }) => {
    const { hashToken } = await import("./mcp/booking.server");
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: row } = await (supabaseAdmin as any)
      .from("mcp_booking_links")
      .update({ used_at: new Date().toISOString() })
      .eq("token_hash", hashToken(data.token))
      .is("used_at", null)
      .gt("expires_at", new Date().toISOString())
      .select("activity_id, date, start_time_id, quantities, pickup_zone")
      .maybeSingle();
    if (!row) return { ok: false as const };
    return {
      ok: true as const,
      activityId: String(row.activity_id),
      date: String(row.date),
      startTimeId: row.start_time_id == null ? null : Number(row.start_time_id),
      quantities: (row.quantities ?? {}) as Record<string, number>,
      pickupZone: (row.pickup_zone as string | null) ?? null,
    };
  });
